import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TellentHttpApiService } from '@core/tellent-http-legacy';

import type { TellentTwoFactorAuthenticationSetup } from '../types';

@Injectable({ providedIn: 'root' })
export class TellentTwoFactorAuthenticationHttpClient {
  constructor(private httpApi: TellentHttpApiService) {}

  public loadSecuritySetup(): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.httpApi
      .get('/api/two-factor-settings', null, { skipCompany: true })
      .pipe(map(response => response.data));
  }

  public sendSmsCode(phoneNumber: string): Observable<void> {
    return this.httpApi.post(
      '/api/two-factor-settings/send-activation-sms',
      null,
      {
        phone: phoneNumber,
      },
      { skipCompany: true },
    );
  }

  public sendEmailCode(phoneNumber: string): Observable<void> {
    return this.httpApi.post(
      '/api/two-factor-settings/send-email-code',
      null,
      {
        phone: phoneNumber,
      },
      { skipCompany: true },
    );
  }

  public enableSmsAuth(
    phoneNumber: string,
    activationCode: string,
  ): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.httpApi.patch(
      '/api/two-factor-settings/sms/enable',
      null,
      {
        phone: phoneNumber,
        hotpCode: activationCode,
      },
      { skipCompany: true },
    );
  }

  public disableSmsAuth(emailCode: string): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.httpApi.patch(
      '/api/two-factor-settings/sms/disable',
      null,
      {
        emailCode,
      },
      { skipCompany: true },
    );
  }

  public enableAppAuth(activationCode: string): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.httpApi.patch(
      '/api/two-factor-settings/app/enable',
      null,
      {
        totpCode: activationCode,
      },
      { skipCompany: true },
    );
  }

  public disableAppAuth(email_code: string): Observable<TellentTwoFactorAuthenticationSetup> {
    return this.httpApi.patch(
      '/api/two-factor-settings/app/disable',
      null,
      {
        email_code,
      },
      { skipCompany: true },
    );
  }

  // waiting for account recovery
  // public dismissRecoveryInfobox(): Observable<TellentTwoFactorAuthenticationSetup> {
  //   return this.httpApi.patch(
  //     '/two-factor-settings/hide-account-recovered-infobox',
  //     null,
  //     {},
  //     { skipCompany: true },
  //   );
  // }
}
